module.exports = __webpack_public_path__ + "img/Legend.12d01494.png";